import { useQuery } from "@tanstack/react-query";
import { fetchAdminEngagementBlueprints } from "PFCore/services/admin/engagement_blueprints";

import { engagementBlueprintsKeys } from "./query_keys";

export const useAdminEngagementBlueprints = (page = 1, perPage = 25) =>
  useQuery({
    queryKey: engagementBlueprintsKeys.list({ page, perPage }),
    queryFn: () => fetchAdminEngagementBlueprints({ page, perPage })
  });
